import { createContext, useState } from 'react';
import { DARK_MAP_STYLE } from '@/components/Map/Utils/mapStyleTypes';
import GraphControls from '../../../../components/Graphs/GraphControls';
import { getUserPreferenceMapLayer } from '../../../../components/Map/Settings/utils';
import { getUserPreferenceMapStyle } from '../../../../components/Map/Utils/mapStyles';
import { CCUS_GOOGLE_ANALYTICS_TAG } from '../../constants';
import {
  INDUSTRY_TYPE,
  mapChartTypes,
  mapSizeTypes,
  TOTAL_CO2_EMISSIONS_SIZE_TYPE,
} from '../utils';
import { layerProps } from './constants';

const MapContext = createContext();

export const MapProvider = ({ children }) => {
  const [graphType, setGraphType] = useState(INDUSTRY_TYPE);
  const [openControlsModal, setOpenControlsModal] = useState(false);
  const [sizeType, setSizeType] = useState(TOTAL_CO2_EMISSIONS_SIZE_TYPE.value);
  const [mapLayers, setMapLayers] = useState(
    getUserPreferenceMapLayer(layerProps.defaultLayer, layerProps.multiple),
  );
  const [style, setStyle] = useState(getUserPreferenceMapStyle(DARK_MAP_STYLE.value));

  return (
    <MapContext.Provider
      value={{
        graphType,
        mapLayers,
        setMapLayers,
        setOpenControlsModal,
        sizeType,
        style,
        setStyle,
        title: 'CCUS Map',
      }}
    >
      {children}
      <GraphControls
        googleAnalyticsTag={CCUS_GOOGLE_ANALYTICS_TAG}
        graphType={graphType}
        open={openControlsModal}
        setGraphType={setGraphType}
        setOpen={setOpenControlsModal}
        setSizeType={setSizeType}
        sizeType={sizeType}
        sizeTypes={mapSizeTypes}
        types={mapChartTypes}
      />
    </MapContext.Provider>
  );
};

export const MapConsumer = MapContext.Consumer;

export default MapContext;
